import style from './TermsAndConditions.module.css'

export default function TermsAndConditions() {
    return (
        <div className="container  pt-4 pb-5 text-start">
            <h2 className="mb-4 text-center">Terms and Conditions</h2>

            <p className={style.text}>
                Welcome to <strong>PeoplePulse</strong>. By accessing or using this website,
                you agree to be bound by the following terms and conditions. Please read
                them carefully before using our services.
            </p>

            <h5 className={style.title}>1. Acceptance of Terms</h5>
            <p className={style.text}>
                By using this website, you acknowledge that you have read, understood,
                and agreed to these terms. If you do not agree, please do not use this
                website.
            </p>

            <h5 className={style.title}>2. User Responsibilities</h5>
            <p className={style.text}>
                You agree to use this platform only for lawful purposes and not to
                engage in any activity that could harm, disable, or interfere with the
                website’s functionality or other users’ experience.
            </p>

            <h5 className={style.title}>3. Account Security</h5>
            <p className={style.text}>
                You are responsible for maintaining the confidentiality of your account
                credentials. Any actions taken under your account are your
                responsibility.
            </p>

            <h5 className={style.title}>4. Intellectual Property</h5>
            <p className={style.text}>
                All content, logos, and designs on this site are owned by PeoplePulse
                unless otherwise stated. Unauthorized use or duplication of materials is
                prohibited.
            </p>

            <h5 className={style.title}>5. Limitation of Liability</h5>
            <p className={style.text}>
                PeoplePulse is not liable for any damages resulting from the use or
                inability to use our website, including data loss, unauthorized access,
                or downtime.
            </p>

            <h5 className={style.title}>6. Changes to Terms</h5>
            <p className={style.text}>
                We may update these Terms and Conditions at any time. Continued use of
                the website after such changes implies your acceptance of the revised
                terms.
            </p>

            <h5 className={style.title}>7. Contact Us</h5>
            <p className={style.text}>
                If you have questions about these Terms, contact us at{" "}
                <a href="mailto:support@peoplepulse.com">support@peoplepulse.com</a>.
            </p>
        </div>
    );
}
